import GateCards from './GateCards';
import GateCardDetail from './GateCardDetail';

export {GateCards, GateCardDetail};
